import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import React from "react";
import PersonIcon from "@mui/icons-material/Person";

export enum UserRole {
    CLIENT = 'CLIENT',
    ACCOUNTANT = 'ACCOUNTANT',
}


export function roleIcon(role: UserRole) {
    if (role === UserRole.ACCOUNTANT) {
        return <AccountBalanceIcon/>;
    } else {
        return <PersonIcon/>
    }
}